import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as s } from "tslib";
import { LitElement as i, html as r } from "lit";
import { stylesBase as o } from "./navigation-styles.js";
import n from "../../styles/global-styles.js";
import { property as l } from "lit/decorators.js";
import { setPotentialAttribute as p } from "../../../utilities/utils.js";
var u, a, f, h;
class d extends i {
  constructor() {
    super(...arguments), u.set(this, "Huvudmeny"), a.set(this, !1), f.set(this, !1), h.set(this, void 0);
  }
  get srtext() {
    return e(this, u, "f");
  }
  set srtext(t) {
    s(this, u, t, "f");
  }
  get unresponsive() {
    return e(this, a, "f");
  }
  set unresponsive(t) {
    s(this, a, t, "f");
  }
  get fluid() {
    return e(this, f, "f");
  }
  set fluid(t) {
    s(this, f, t, "f");
  }
  get type() {
    return e(this, h, "f");
  }
  set type(t) {
    s(this, h, t, "f");
  }
  firstUpdated(t) {
    super.firstUpdated(t);
    const e = this.closest("ids-header");
    this.setAttribute("slot", "header-nav"), this.setAttribute("type", e.getAttribute("type")), null !== e.getAttribute("unresponsive") && (this.unresponsive = !0), null !== e.getAttribute("fluid") && (this.fluid = !0), this.querySelectorAll("ids-header-nav-item")?.forEach(t => {
      p(t, "type", this.type), p(t, "unresponsive", this.unresponsive), p(t, "fluid", this.fluid);
    });
  }
  render() {
    return r`<nav class="navigation type-${this.type}" aria-label="${this.srtext}"><ids-container ?fluid="${this.fluid}" gutterless><ids-row class="nav-row"><slot></slot></ids-row></ids-container></nav>`;
  }
}
u = new WeakMap(), a = new WeakMap(), f = new WeakMap(), h = new WeakMap(), d.styles = [n, o], t([l({
  type: String
})], d.prototype, "srtext", null), t([l({
  type: Boolean,
  reflect: !0
})], d.prototype, "unresponsive", null), t([l({
  type: Boolean,
  reflect: !0
})], d.prototype, "fluid", null), t([l({
  type: String,
  reflect: !0
})], d.prototype, "type", null);
export { d as IDSHeaderNav };